import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useAppSelector } from 'app/store/store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import { sitemap } from 'app/shared/util/url-utils';
import { useRestrictedPage } from '../hooks/useRestrictedPage';
import { accountProfileApi } from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';
import { AccountRead, AccountStatus } from 'app/store/reducers/api/config-manager-cloud-services/store/types';

export const AppBackdropWrapper = () => {
  useRestrictedPage();
  const { appLoading, appStarting } = useAppSelector(state => state.appState);
  const { data: accountProfile = {} as AccountRead } =
    accountProfileApi.endpoints.getCurrentAccountProfile.useQueryState();
  const location = useLocation();

  const isInviteAccept = /^\/invitations\/[^/]+\/accept$/.test(location.pathname);

  if (!accountProfile.status) return;
  if (accountProfile.status === AccountStatus.BOOTSTRAP && !isInviteAccept)
    return <Navigate replace to={sitemap.welcome} />;
  return (
    <Box sx={{ m: 2, height: '97%' }}>
      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={appLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {!appStarting && <Outlet />}
    </Box>
  );
};
